export default "__VITE_ASSET__1a8f1062__"